// Hero trend chart height per breakpoint. Shared by the Hero, its empty-state
// placeholder and the skeleton so all three reserve the same vertical space and
// the page never shifts as data loads in.
export const HERO_CHART_HEIGHT = {
  compact: 280,
  regular: 360,
} as const;
